import { makeStyles } from 'tss-react/mui';
import {darkGrey} from "../../../globalStyle";

const useStyles = makeStyles()((theme) => ({
  title: {
    display: 'flex',
    flexDirection: 'row',
  },
  tpSearch: {
    padding: "1.5rem",
    backgroundColor: "#F2F3F7",
    marginTop: "10px",
  },
  tpSearchContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    "& .MuiInputLabel-root": {
      fontSize: "0.75rem",
      marginBottom: "0.5rem",
      color: darkGrey,
    },
    "& .MuiTypography-body1": {
      fontSize: "0.75rem",
      color: darkGrey,
    },
    "& .MuiSelect-root": {
      background: "white",
      padding: "0.5rem 0.75rem",
    },
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
    },
    "&:nth-of-type(1)": {
      maxWidth: "300px"
    },
    "&:nth-of-type(2)": {
      maxWidth: "300px"
    },
  },
  countriesPaper: {
    maxHeight: "50%",
  },
  searchByRadios: {
    marginBottom: "0.5rem",
    "& .searchRadiosContainer": {
      display: "flex",
      alignItems: "center",
    },
    "& .MuiFormGroup-root": {
      display: "inline",
      marginLeft: "1rem",
    },
    "& .MuiRadio-root": {
      marginRight: "0.25rem",
    },
  },
  tpSearchBtn: {
    marginTop: "36px",
    textTransform: "none",
    float: "right",
    fontSize: "12px",
  },
  divider: {
    margin: "2rem 0",
  },
  resultWarning: {
    color: "#7E7E8F",
    marginTop: "20px"
  },
  iconWarning: {
    marginRight: "5px",
    position: "relative",
    top: "5px"
  },
  tableContainer: {
    padding: "0 !important",
  },
  addNewThirdparty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    marginBottom: "30px"
  },
  notFoundingThirdParty: {
    color: "#9A9AAF",
    fontWeight: "600",
    fontSize: "18px",
  },
  youCanCreateThirdParty: {
    color: "#373534",
    fontWeight: "400",
    fontSize: "16px",
    marginBottom: "5px"
  },
  icon: {
    display: "inline-block",
  },
  addIconWrapper: {
    backgroundColor: theme.palette.primary.primary200,
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    marginRight: "1rem",
    position: 'relative',
    top: "-4px"
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: "14px !important",
    gap: "42px",
  },
  inputLabel: {
    color: "#7E7E8F !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    marginBottom: "20px !important",
    fontFamily: "Inter !important"
  },
  resultTitle: {
    display: "flex",
    alignItems: "center",
  },
  resultsCounter: {
    color: "#C6CBD9",
    fontSize: "12px",
    marginLeft: "10px",
    position: "relative",
    top: "2px"
  },
  iconWrapper: {
    height: "28px",
    width: "28px",
    borderRadius: "6px",
    marginRight: "5px",
    position: 'relative',
    top: "-2px"
  },

  // no results
  noResultWrapper: {
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    borderRadius: "12px",
    boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.07)",
    marginTop: "22px"
  },
  notFoundingResult: {
    color: "#9A9AAF",
    fontWeight: "600",
    fontSize: "18px",
    marginBottom: "19px !important",
  }
}));

export default useStyles;
